import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "sort_down",
  "use": "sort_down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"sort_down\"><defs><style type=\"text/css\"></style></defs><path d=\"M863.321996 251.674996 194.108395 251.674996 528.677333 621.186771Z\" p-id=\"1351\" fill=\"#bebebe\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sort_down.svg
// module id = evBo
// module chunks = 37